import { PrometheusQuerySpec } from '@/core';
import { ResponseHandler, ResultType } from '../types';
import {
  NATIVE_HISTOGRAM_ERROR_MESSAGE,
  TIMESERIES_HISTOGRAM_ERROR_MESSAGE,
  transformTimeSeriesToSingleValue,
} from './utils';

export const singleValueResponseHandler: ResponseHandler = {
  [ResultType.NativeHistogram]: () => {
    throw new Error(NATIVE_HISTOGRAM_ERROR_MESSAGE);
  },
  [ResultType.TimeSeriesHistogram]: () => {
    throw new Error(TIMESERIES_HISTOGRAM_ERROR_MESSAGE);
  },
  [ResultType.TimeSeries]: (result, metadata, _notices, context) => {
    const singleValueData = transformTimeSeriesToSingleValue({
      result,
      spec: context.spec as PrometheusQuerySpec,
      compareResult: context.compareResult,
      alias: context.alias,
      alignedEndMs: context.end * 1000,
    });

    return {
      type: 'SingleValue',
      data: {
        values: singleValueData,
        metadata,
      },
    };
  },
};
